/**
 * Created by Victor Rojo on 9/5/19.
 */
import { Component }     from '@angular/core';

@Component({
  templateUrl: './Journal.component.html',
  styleUrls: ['./Journal.component.css']
})
export class JournalComponent {

}
